import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CollectUserEventDataPng2x from './assets/CollectUserEventData@2x.png'
import CollectUserEventDataWebp from './assets/CollectUserEventData.webp'
import CollectUserEventDataWebp2x from './assets/CollectUserEventData@2x.webp'

const CollectUserEventDataImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${CollectUserEventDataWebp}, ${CollectUserEventDataWebp2x} 2x`} />
      <Image
        width="618"
        height="946"
        src={CollectUserEventDataPng2x}
        alt="Illustration: Collect User Event Data"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[1]});
`

export default CollectUserEventDataImage
